module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h2', {
    staticClass: "CH1_Chapter_title_1 ParaOverride-2",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v("Also by Christopher Brookmyre")])]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Quite Ugly One Morning")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Country of the Blind")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Not the End of the World")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("One Fine Day in the Middle of the Night")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Boiling a Frog")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("A Big Boy Did It and Ran Away")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("The Sacred Art of Stealing")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Be My Enemy")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("All Fun and Games until Somebody Loses an Eye")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("A Tale Etched in Blood and Hard Black Pencil")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Attack of the Unsinkable Rubber Ducks")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("A Snowball in Hell")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Pandaemonium")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Where the Bodies are Buried")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("When the Devil Drives")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Bedlam")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Bred in the Bone")]), _vm._v(" "), _c('p', {
    staticClass: "ABL_Also_by_list_item"
  }, [_vm._v("Dead Girl Walking")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3885697a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RR0208-1.vue
// module id = 66
// module chunks = 0